var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormBaseElement, XbpmActionType, FormulaChangeProperty, } from '@unitarius/xbpm-runtime';
import { propEq, path } from 'ramda';
import { Dialog } from 'primereact/dialog';
import { prefixValue } from '../../common/utils/_.utils';
import { mapElementClass } from '../../common/utils/element.utils';
import { TreeListContainer } from './TreeList';
var GroupContainer = /** @class */ (function (_super) {
    __extends(GroupContainer, _super);
    function GroupContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = __assign(__assign({}, _this.state), { iFrameLoaded: false });
        _this.getClass = function (frontOptions, IsContentTree) {
            var isModal = frontOptions.isModal, _a = frontOptions.className, className = _a === void 0 ? '' : _a, isPrintable = frontOptions.isPrintable;
            return ("" + mapElementClass(frontOptions) + (IsContentTree ? ' p-col' : '') + (isPrintable === false ? ' HideForPrint' : '') + (!isModal ? prefixValue(className, ' ') : '')).trim();
        };
        _this.handleModalClose = function () {
            _this.props.onEvent({
                target: {
                    frontFormulas: {
                        formulaFrontClick: function () { return ({ id: _this.state.def.id, $kind: FormulaChangeProperty.HIDDEN, value: true }); },
                    },
                },
                type: XbpmActionType.FRONT_CLICK,
            });
        };
        return _this;
    }
    // check if iframe is direct child of a group
    GroupContainer.prototype.isIframeParent = function (def) {
        var isIframe = propEq('kind', 'IFRAME');
        var isPanel = propEq('kind', 'PANEL');
        var hasElements = path(['elements']);
        var next;
        if (hasElements(def) && def.elements.length) {
            next = def.elements[0];
            if (isPanel(next) && hasElements(next)) {
                next = next.elements[0];
                return isIframe(next);
            }
            return false;
        }
        return false;
    };
    GroupContainer.prototype.componentDidUpdate = function (_, prevState) {
        // change state to mounted, if component hidden prop change from true to false, and group contains iframe as direct child
        if (!this.state.iFrameLoaded) {
            if (!this.state.def.hidden && prevState.def.hidden && this.isIframeParent(this.state.def)) {
                this.setState({ iFrameLoaded: true });
            }
        }
    };
    GroupContainer.prototype.elementRender = function (def) {
        var isModal = def.frontOptions.isModal;
        return isModal ? this.renderModal(def) : this.renderGroup(def);
    };
    GroupContainer.prototype.renderGroup = function (def) {
        var frontOptions = def.frontOptions, id = def.id, header = def.header, hidden = def.hidden;
        var _a = frontOptions.style, style = _a === void 0 ? {} : _a, isModal = frontOptions.isModal, isContentTree = frontOptions.isContentTree, isPrintableHeader = frontOptions.isPrintableHeader, isBorderVisible = frontOptions.isBorderVisible;
        var iFrameLoadedAndIsHidden = this.state.iFrameLoaded && hidden;
        var display = iFrameLoadedAndIsHidden ? { display: 'none' } : {};
        // the group does not unmount self after first mount (case with direct iframe child only)
        return hidden && !isModal && !this.state.iFrameLoaded ? null : (React.createElement("div", { id: id, hidden: hidden && !this.state.iFrameLoaded, 
            // the group only change it's display prop after consequent frontVisibilty formula result change (case with direct iframe child only)
            style: !isModal ? __assign(__assign({}, style), display) : {}, className: this.getClass(frontOptions, false) },
            React.createElement("div", { className: isBorderVisible ? ' GroupBorder' : '' },
                !isModal && (header || frontOptions.header) && (React.createElement("div", { className: 'p-col' + (isPrintableHeader === false ? ' HideForPrint' : '') + ' title-panel title-panel--group' }, header || frontOptions.header)),
                !isContentTree ? (this.renderChildren()) : (React.createElement("div", { className: "p-grid", key: id + "-tree" },
                    React.createElement(TreeListContainer, { def: def }),
                    React.createElement("div", { className: "p-col" },
                        React.createElement("div", { className: this.getClass(frontOptions, isContentTree) }, this.renderChildren())))))));
    };
    GroupContainer.prototype.renderModal = function (def) {
        var _a = def.frontOptions, header = _a.header, className = _a.className, _b = _a.style, style = _b === void 0 ? {} : _b;
        return (React.createElement(Dialog, { visible: !def.hidden, header: def.header || header, onHide: this.handleModalClose, style: style, className: 'ModalGroup' + prefixValue(className, ' '), contentStyle: { maxHeight: window.innerHeight - 100, overflowY: 'auto' } }, this.renderGroup(def)));
    };
    return GroupContainer;
}(FormBaseElement));
export { GroupContainer };
//# sourceMappingURL=Group.js.map